import React, { useState } from 'react';
// import Button from '@mui/material/Button';
// import Menu from '@mui/material/Menu';
// import MenuItem from '@mui/material/MenuItem';
import classes from './Header.module.css';
import napa_logo from '../../images/napa_logo.png';
import user_icon from '../../images/user_icon.png';
import { useNavigate } from "react-router-dom";
import { getToken } from "../shared/TokenInformation/TokenInformation"
import { Box, Collapse, Drawer, IconButton, List, ListItem, ListItemText, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';


function Header(props) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openSubmenu, SetOpenSubMenu] = useState(null);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);

    if (!open) {
      SetOpenSubMenu(null); // Reset submenu when drawer is closed
    }
  }
  const handleSubmenuToggle = (index) => {
    SetOpenSubMenu(prev => (prev === index ? null : index))
  }

  const nav = useNavigate();

  const handleManageUsersBtnClick = () => {
    nav("/manage-users")

  }

  // const handleCostUploadBtnClick = () => {
  //   nav("/cost-upload")
  // }

  // const handleCostUploadHistoryBtnClick = () => {
  //   nav("/cost-upload-history")
  // }

  const menuItems = [
    // {
    //   text: 'Dashboard',
    //   path: '/dashboard'
    // },
    // {
    //   text: 'User Assignment',
    //   path: '/user-assignment'
    // },
    {
      text: 'CJW',
      children: [
        { text: 'Upload CJW', path: '/cjw-Upload' },
        // { text: 'Compare CJW', path: '/compare-cjw' , disabled: true},
        // { text: 'Approve CJW', path: '/approve-cjw' , disabled: true },
        { text: 'CJW Manage History', path: '/cjw-manage-history' }

      ]
    },
    {
      text: 'Cost File',
      children: [
        { text: 'Upload Cost Data', path: '/cost-upload' },
        { text: 'Cost Upload History', path: '/cost-upload-history' },
      ]
    },
    {
      text: 'Secondary Cost ASG',
      children: [
        { text: 'Upload File', path: '/svc-upload' },
        { text: 'SVC Manage History', path: '/svc-manage-history' }
      ]
    },
    {
      text: 'LC Business Data Uploads',
      children: [
        {text: 'Vendor to Container mapping Upload', path: '/landed-cost/upload-vendor'},
        {text: 'SKU exclusion from Tariff', path: '/landed-cost/sku-exclusion'},
        {text: 'Anti Dumping & Counter Vailing adjustments', path: '/landed-cost/anti-dumping'},
        {text: 'Tariff Rates Upload', path: '/landed-cost/tariff-data'},
        {text: 'Container Rates Upload', path: '/landed-cost/container-rate'},
      ]
    },
    // {
    //   text: 'Landed cost calculation (not part of final version)',
    //   children: [
    //     {text: 'Calculate landed cost', path: '/landed-cost/calculation'}
    //   ]
    // },
    {
      text: 'Landed Result Data',
      children: [
        {text: 'Landed Cost Results', path: '/landed-cost/results' },
        //{text: 'New Item Flow', path: '/landed-cost/new-item-view'},
        //{text: 'Flagged Items', path: '/flagged-items'},
        {text: 'Rules', path: '/rules'},
      ]
    },
    {
      text: 'Landed Cost Data',
      children: [
        {text: 'Data View', path: '/landed-cost/data-view'},
      ]
    },
    {
      text: 'DC Cost',
      children: [
        { text: 'Blocked Items / Flagged Items', path: '/dc-cost/blocked-items' },
        { text: 'DC Cost Result', path: '/dc-cost/approvals' },
        { text: 'Manual pull', path: '/dc-cost/manual-pull' },
        { text: 'Escalated items', path: '/dc-cost/escalation-reviews' },
      ]
    },
   
  ]
  const tokenInfo = getToken();
  const userName = tokenInfo && tokenInfo.username ? tokenInfo.username.split("@")[0] : "";
  const manageUsersLink = (
    <div className={classes.dashboardTextHeader}>
      <button
        className={`${classes.dashboardButton} ${classes.headerLinkBtn}`}
        type="button"
        onClick={handleManageUsersBtnClick}
      >
        {" "}
        <span>Manage Users</span>
      </button>
    </div>
  );

// commented for eslint error
  // const costUploadLink = (
  //   <div className={classes.dashboardTextHeader}>
  //     <button
  //       className={`${classes.dashboardButton} ${classes.headerLinkBtn}`}
  //       type="button"
  //       onClick={handleCostUploadBtnClick}
  //     >
  //       {" "}
  //       <span>Upload Cost Data</span>
  //     </button>
  //   </div>
  // );

  // commented for eslint error
  // const costUploadHistoryLink = (
  //   <div className={classes.dashboardTextHeader}>
  //     <button
  //       className={`${classes.dashboardButton} ${classes.headerLinkBtn}`}
  //       type="button"
  //       onClick={handleCostUploadHistoryBtnClick}
  //     >
  //       {" "}
  //       <span>Cost Upload History</span>
  //     </button>
  //   </div>
  // );

  return (
    <div className={classes.header}>
      <div className={classes.headerSection}>
        <IconButton edge="start" color="inherit" onClick={toggleDrawer(true)} aria-label='menu'>
          <MenuIcon className={classes.MenuIconColor} />
        </IconButton>
        <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)} PaperProps={{ className: classes.drawer }} ModalProps={{ keepMounted: false }} >
          <Box className={classes.boxWidth} role="presentation">
            <List>
              {menuItems.map((items, index) => {
                if (items.children) {
                  return (
                    <Box key={items.text}>

                      <ListItem button onClick={() => handleSubmenuToggle(index)} sx={{ className: classes.listItem }}>
                        <ListItemText primary={<Typography variant='body1' className={classes.typo}> {items.text} </Typography>} />
                        {openSubmenu === index ? <ExpandLess /> : <ExpandMore />}
                      </ListItem>
                      <Collapse in={openSubmenu === index} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                          {items.children.map((child) => (
                            <ListItem key={child.text} button component={Link} to={child.path} onClick={toggleDrawer(false)} sx={{ className: classes.subListItem }}>
                              <ListItemText primary={<Typography className={classes.listItemText}>
                                {child.text}
                              </Typography>}
                              />
                            </ListItem>
                          ))}
                        </List>
                      </Collapse>
                    </Box>
                  );
                } else {
                  return (
                    <ListItem key={items.text} button component={Link} to={items.path} onClick={toggleDrawer(false)} sx={{ className: classes.menuListItem }}>
                      <ListItemText primary={<Typography className={classes.typo}>
                        {items.text}
                      </Typography>
                      }
                      />
                    </ListItem>
                  )
                }
              }
              )}
            </List>
          </Box>
        </Drawer>
        <img
          data-testid="logo"
          className={classes.headerNapaLogo}
          src={napa_logo}
          alt="napa_logo"
        />
        <p className={classes.headerText}>COST MANAGEMENT PORTAL </p>
      </div>
      { }
        <div className={classes.headerSection}>
          {/* Commenting below lines as the menu items are included in left nav */}
        {/* {costUploadLink}
        <div className={classes.pipeSignHeader}></div>
        {costUploadHistoryLink}
        <div className={classes.pipeSignHeader}></div> */}
        
        {manageUsersLink}
        <div className={classes.pipeSignHeader}></div>
        <div>
          <img
            data-testid="userIcon"
            src={user_icon}
            className={classes.userIcon}
            alt="user_icon"
          />
        </div>

        <div>
          <p className={classes.accountName}>{userName}</p>
        </div>
      </div>
    </div>
  );
}

export default Header;
